export default __webpack_public_path__ + "static/journal_cover_image-670503cf34cf80efc1e4001809330f61.png";